class TimeFormatter {
    /**
     * @param {number} ms 
     * @param {{seconds: string, minutes: string, hours: string}} [labels]
     */
    static formatMilliseconds(ms, labels) {
        labels = labels || {
            hours: "hours",
            minutes: "minutes",
            seconds: "seconds",
        };

        const s = Math.floor(ms / 1000) % 60;
        const m = Math.floor(ms / (60 * 1000)) % 60;
        const h = Math.floor(ms / (60 * 60 * 1000));

        const list = [
            {val: h, label: labels.hours},
            {val: m, label: labels.minutes},
            {val: s, label: labels.seconds},
        ];

        const parts = [];

        for (const el of list) {
            if (el.val > 0)
                parts.push(`${el.val} ${el.label}`);
        }

        return parts.join(" ") || "-";
    }

    /**
     * @param {number} seconds 
     * @param {{seconds: string, minutes: string, hours: string}} [labels]
     */
    static formatSeconds(seconds, labels) {
        return this.formatMilliseconds(seconds * 1000, labels);
    }
}

export default TimeFormatter;